import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const SiteSettingsContext = createContext({});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    try {
      const cached = sessionStorage.getItem('siteSettings');
      if (cached) return JSON.parse(cached);
    } catch (e) { /* ignore */ }
    return null;
  });
  const [loading, setLoading] = useState(!settings);

  useEffect(() => {
    if (settings) return; // already have data from sessionStorage
    // Delay fetch by 100ms to let LCP resources (hero image, critical CSS) claim bandwidth first
    const timer = setTimeout(async () => {
      try {
        const response = await fetch('/api/site-settings-api');
        if (response.ok) {
          const data = await response.json();
          const s = data.settings || {};
          setSettings(s);
          try { sessionStorage.setItem('siteSettings', JSON.stringify(s)); } catch (e) { /* ignore */ }
        }
      } catch (error) {
        // silent fail - components use their own defaults
      } finally {
        setLoading(false);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [settings]);

  const value = useMemo(() => ({ settings: settings || {}, loading }), [settings, loading]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
